import {dispatch} from "../store";
import * as toolkitRaw from "@reduxjs/toolkit";
import {generateThemeId} from "@/utils/utils";

const {createSlice} = toolkitRaw.default ?? toolkitRaw;

import themesOptions from "@/theme/themeOptions";

const defaultThemeId = generateThemeId({
  theme: themesOptions['dark'],
});
const themeObject = {}
const initialState = {
  loading: false,
  themeId: defaultThemeId,
  themeOptions: themesOptions,
  themeObject,
  name: "spiderPoolTheme",
};

const slice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    updateTheme: (state, {payload: themeObject}) => {
      state.themeObject = themeObject;
    },
    updateThemeOptions: (state, {payload: themeOptions}) => {
      state.themeOptions = themeOptions;
    },
    startLoading(state, {}) {
      state.loading = true;
    },
    stopLoading(state, {}) {
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const {updateTheme,
  updateThemeOptions,
  startLoading,
  stopLoading
} = slice.actions;
